import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";
import { IMAGES } from "@/lib/assets";
import { ArrowUpRight } from "lucide-react";

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <section
      className="relative py-24 md:py-36 bg-sand"
      data-testid="services"
      style={{ backgroundImage: `linear-gradient(rgba(242,235,229,0.92), rgba(242,235,229,0.96)), url(${IMAGES.luxury})`, backgroundSize: "cover", backgroundPosition: "center" }}
    >
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <Reveal className="max-w-2xl mb-16">
          <span className="font-sans uppercase tracking-[0.35em] text-[11px] text-amber-deep">What We Offer</span>
          <h2 className="mt-5 font-serif text-4xl md:text-6xl leading-[0.95] text-obsidian">
            Care, the HairPrive way.
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-px bg-black/10 border border-black/10">
          {services.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.06} className="bg-cream p-8 md:p-12">
              <div className="flex items-baseline gap-4">
                <span className="font-serif text-3xl text-amber/70">0{i + 1}</span>
                <span className="font-sans uppercase tracking-[0.2em] text-[10px] text-clinical">{s.system}</span>
              </div>
              <h3 className="mt-4 font-serif text-3xl text-obsidian">{s.title}</h3>
              <p className="mt-3 font-sans font-light text-obsidian/70 leading-relaxed max-w-md">{s.description}</p>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-12 flex flex-wrap gap-4">
          <Link to="/consultation" className="group inline-flex items-center gap-2 bg-obsidian text-cream px-8 py-4 font-sans uppercase tracking-[0.2em] text-xs hover:bg-amber-deep transition-colors">
            Book a consultation
            <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </Link>
          <Link to="/analysis" className="inline-flex items-center gap-2 border border-obsidian/20 px-8 py-4 font-sans uppercase tracking-[0.2em] text-xs hover:border-obsidian transition-colors">
            Try AI analysis
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
